interface PaginationProps {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, pageSize, onChange }: PaginationProps) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  if (pageCount <= 1) return null;

  const pages = Array.from({ length: pageCount }, (_, index) => index + 1);

  return (
    <nav aria-label="分页导航" className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`h-9 w-9 rounded-md border text-sm transition-colors ${
            page === current
              ? "border-primary-500 bg-primary-500 font-semibold text-background-50"
              : "border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(pageCount, current + 1))}
        disabled={current === pageCount}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}